import React from 'react';
import UploadPictures from "./UploadPictures";

class FileUpload extends React.Component {

  render() {
    const { ...attributes} = this.props;

    return (
      <UploadPictures beforeUpload={this.props.handleUpload} {...attributes}/>
    )
  }
}


export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/common/upload/FileUpload.js